import React from "react";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "./PrivateRoute";
import LoginPage from "../containers/LoginPage";
import ForgotPasswordPage from "../containers/ForgotPasswordPage";
import ResetPasswordPage from "../containers/ResetPasswordPage";
import DashboardPage from "../containers/DashboardPage";
import LeadsPage from "../containers/LeadsPage";
import LeadAddPage from "../containers/LeadAddPage";
import LeadEditPage from "../containers/LeadEditPage";
import AdminLeadsSummary from "../containers/AdminLeadsSummary";
import AdminPostedReport from "../containers/AdminPostedReport";
import AdminAttemptedReport from "../containers/AdminAttemptedReport";
import AdminTargetsPage from "../containers/AdminTargetsPage";
import AdminSourceWisePostingReport from "../containers/AdminSourceWisePostingReport";
import AdminSourceWiseDetailedReport from "../containers/AdminSourceWiseDetailedReport";
import AdminCampaignsPage from "../containers/AdminCampaignsPage";
import AdminLocationsPage from "../containers/AdminLocationsPage";
import AdminManageSpendPage from "../containers/AdminManageSpendPage";
import AdminSpentReportPage from "../containers/AdminSpentReportPage";
import AdminMonthlyBudgetReportPage from "../containers/AdminMonthlyBudgetReportPage";
import AdminBudgetSummaryReportPage from "../containers/AdminBudgetSummaryReportPage";

import TeamsPage from "../containers/TeamsPage";
import IncentivesPage from "../containers/IncentivesPage";
import TeamDashboardPage from "../containers/TeamDashboardPage";
import ExecutiveFlaggedLeads from "../containers/ExecutiveFlaggedLeads";
import { PERMISSION } from "../utils/constants";
import { hasPermission } from "../utils/permissions";

const Router = ({ permissions }) => {
  const defaultPath = hasPermission(permissions, PERMISSION.ADMIN_SUMMARY_ACCESS)
    ? "/admin/summary"
    : hasPermission(permissions, PERMISSION.REPORT_POSTED_ACCESS)
    ? "/admin/report/posted"
    : hasPermission(permissions, PERMISSION.MARKETING_SPEND_ACCESS)
    ? "/admin/marketing/spend"
    : "/leads";

  return (
    <Switch>
      <Route exact path="/login" component={LoginPage} />
      <Route exact path="/forgot-password" component={ForgotPasswordPage} />
      <Route exact path="/reset-password" component={ResetPasswordPage} />
      {/* <PrivateRoute exact path="/dashboard" component={DashboardPage} /> */}
      <PrivateRoute exact path="/leads" component={LeadsPage} requirePermissions={[PERMISSION.LEADS_ACCESS]} />
      <PrivateRoute exact path="/leads/add" component={LeadAddPage} requirePermissions={[PERMISSION.LEADS_ACCESS]} />
      <PrivateRoute exact path="/leads/:id/edit" component={LeadEditPage} requirePermissions={[PERMISSION.LEADS_ACCESS]} />
      <PrivateRoute exact path="/admin/summary" component={AdminLeadsSummary} requirePermissions={[PERMISSION.ADMIN_SUMMARY_ACCESS]} />
      <PrivateRoute exact path="/admin/report/posted" component={AdminPostedReport} requirePermissions={[PERMISSION.REPORT_POSTED_ACCESS]} />
      <PrivateRoute exact path="/admin/report/attempted" component={AdminAttemptedReport} requirePermissions={[PERMISSION.REPORT_ATTEMPTED_ACCESS]} />
      <PrivateRoute exact path="/admin/report/source-wise-posting" component={AdminSourceWisePostingReport} requirePermissions={[PERMISSION.REPORT_SOURCE_POSTING_ACCESS]} />
      <PrivateRoute exact path="/admin/report/source-wise-detailed" component={AdminSourceWiseDetailedReport} requirePermissions={[PERMISSION.REPORT_SOURCE_DETAILED_ACCESS]} />
      <PrivateRoute exact path="/admin/targets" component={AdminTargetsPage} requirePermissions={[PERMISSION.TARGETS_ACCESS]} />
      <PrivateRoute exact path="/admin/settings/campaigns" component={AdminCampaignsPage} requirePermissions={[PERMISSION.SETTINGS_CAMPAIGNS_ACCESS]} />
      <PrivateRoute exact path="/admin/settings/locations" component={AdminLocationsPage} requirePermissions={[PERMISSION.SETTINGS_LOCATIONS_ACCESS]} />
      <PrivateRoute exact path="/admin/marketing/spend" component={AdminManageSpendPage} requirePermissions={[PERMISSION.MARKETING_SPEND_ACCESS]} />
      <PrivateRoute exact path="/admin/marketing/report" component={AdminSpentReportPage} requirePermissions={[PERMISSION.MARKETING_REPORT_ACCESS]} />
      <PrivateRoute exact path="/admin/marketing/monthly-report" component={AdminMonthlyBudgetReportPage} requirePermissions={[PERMISSION.MARKETING_REPORT_ACCESS]} />
      <PrivateRoute exact path="/admin/marketing/budget-summary" component={AdminBudgetSummaryReportPage} requirePermissions={[PERMISSION.MARKETING_REPORT_ACCESS]} />

      {/* Teams, Incentives, and Team Dashboard */}
      <PrivateRoute exact path="/teams" component={TeamsPage} requirePermissions={[PERMISSION.TEAMS_ACCESS]} />
      <PrivateRoute exact path="/incentives" component={IncentivesPage} requirePermissions={[PERMISSION.INCENTIVES_ACCESS]} />
      <PrivateRoute exact path="/team-dashboard" component={TeamDashboardPage} requirePermissions={[PERMISSION.TEAM_DASHBOARD_ACCESS]} />
      <PrivateRoute exact path="/executive/report/flagged" component={ExecutiveFlaggedLeads} requirePermissions={[PERMISSION.FLAGGED_LEADS_ACCESS]} />

      <Redirect from="/" to={defaultPath} />
    </Switch>
  );
};

const mapStateToProps = (state) => ({ permissions: state.permissions });

export default withRouter(connect(mapStateToProps)(Router));
